import { Component, OnInit } from "@angular/core";
import { UserService } from "../services/user.service";
import { OfframpService } from "../services/offramp.service";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

import { MatDatepickerInputEvent, MatDialog } from "@angular/material";
import * as moment from "moment";
import { ProperJsonDialogComponent } from '../properJsonDialog/properjsondialog.component';
import { TableUtil } from "../admintrademaster/tableUtil";
import { NotificationsService } from "angular2-notifications";
import { ColDef, GridOptions, GridApi, ColumnApi } from "ag-grid-community";
import { AddOfframpTradeDialog } from "./add-offramp-trade/add-offramp-trade.component";
import { BulkUploadOfframpTradeDialog } from "./bulk-upload-offramp-trade/bulk-upload-offramp-trade.component";

const defaults = {
  notif: {
    timeOut: 3000,
    showProgressBar: true,
    pauseOnHover: false,
    clickToClose: true,
    maxLength: 50,
  },
};

@Component({
  selector: "app-offramp-trades",
  templateUrl: "./offramp-trades.component.html",
  styleUrls: ["./offramp-trades.component.css"],
})
export class OfframpTradesComponent implements OnInit {
  _csrf: string;
  request_id: string = "";

  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  gridOptions: GridOptions;
  columnDefs: ColDef[] = [];
  rowData: any[] = [];
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100
  };

  oTrades: any = [];
  trades: any = [];
  searchValue: string = '';
  typeOptions = ['BUY', 'SELL'];
  statusOptions = ['COMPLETED', 'PENDING', 'FAILED', 'REJECTED'];
  filter: any = {
    page: 1,
    limit: 100,
    Type: '',
    exchangeTradeStatus: '',
    fromDate: moment().subtract(30, "d").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
  };
  prev_disabled = true;
  next_disabled = false;

  myFilter = (d: Date | null): boolean => {
    return true;
  };

  constructor(
    private router: Router,
    private notifSer: NotificationsService,
    private userService: UserService,
    private offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog
  ) {
    this.initializeGrid();
  }

  ngOnInit() {
    this.csrf();
  }

  initializeGrid() {
    this.columnDefs = [
      {
        headerName: 'Action',
        field: 'action',
        cellRenderer: (params) => {
          if (params.node && params.node.rowPinned) {
            return document.createElement('div');
          }
          const element = params.data;
          const container = document.createElement('div');
          container.style.display = 'flex';
          container.style.alignItems = 'center';

          const viewBtn = document.createElement('button');
          viewBtn.type = 'button';
          viewBtn.className = 'btn btn-sm btn-info';
          viewBtn.title = 'View';
          viewBtn.style.marginRight = '5px';
          viewBtn.innerHTML = '<i class="fa fa-eye"></i>';
          viewBtn.onclick = (e) => {
            e.stopPropagation();
            this.displayProperJson(element, 'Offramp Trade');
          };
          container.appendChild(viewBtn);

          const editBtn = document.createElement('button');
          editBtn.type = 'button';
          editBtn.className = 'btn btn-sm btn-primary';
          editBtn.title = 'Edit';
          editBtn.style.marginRight = '5px';
          editBtn.innerHTML = '<i class="fa fa-edit"></i>';
          editBtn.onclick = (e) => {
            e.stopPropagation();
            this.editRecord(element);
          };
          container.appendChild(editBtn);

          return container;
        },
        sortable: false,
        filter: false,
        flex: 1,
        minWidth: 120
      },
      {
        headerName: 'Date',
        field: 'Date',
        flex: 1
      },
      {
        headerName: 'Key Person',
        field: 'adminid.name',
        valueGetter: (params) => {
          const user = params.data && params.data.adminid;
          if (!user) return '';
          return user.name || user.email || '';
        },
        flex: 1.2
      },
      { headerName: 'Type', field: 'Type', flex: 0.8 },
      {
        headerName: 'Liquidity Provider',
        field: 'liquidity_provider_id.name',
        valueGetter: (params) => {
          const liquidityProvider = params.data && params.data.liquidity_provider_id;
          return (liquidityProvider && liquidityProvider.name) || '';
        },
        flex: 1
      },
      {
        headerName: 'Exchange Quote',
        field: 'exchange_quote_id.rate',
        valueGetter: (params) => {
          const quote = params.data && params.data.exchange_quote_id;
          if (!quote) return '';
          return `${quote.from_currency || ''} -> ${quote.to_currency || ''} @ ${quote.rate != null ? quote.rate : ''}`;
        },
        flex: 1.2
      },
      {
        headerName: 'Rate',
        field: 'Rate',
        valueFormatter: (params) => this.formatNumber(params.value, 2),
        flex: 0.8
      },
      {
        headerName: 'Qty',
        field: 'Qty',
        valueFormatter: (params) => this.formatNumber(params.value, 8),
        flex: 0.9
      },
      {
        headerName: 'Fee %',
        field: 'feePercent',
        valueFormatter: (params) => (params.value || params.value === 0) ? `${Number(params.value).toFixed(3)}%` : '',
        flex: 0.8
      },
      { headerName: 'Tx Hash', field: 'tx_hash', flex: 1 },
      { headerName: 'Exchange Trade Status', field: 'exchangeTradeStatus', flex: 1 },
      {
        headerName: 'Matched Topup Amount',
        field: 'MatchedTopupAmount',
        valueFormatter: (params) => this.formatNumber(params.value, 8),
        flex: 1.1
      },
      {
        headerName: 'Matched Status',
        field: 'MatchedStatus',
        flex: 0.9,
        cellStyle: (params) => this.getStatusCellStyle(params.value),
      },
      {
        headerName: 'CreatedAt',
        field: 'createdAt',
        valueFormatter: (params) => {
          if (params.value) {
            return moment(params.value).format('MMM DD, YYYY hh:mm:ss A');
          }
          return '';
        },
        flex: 1.5
      }
    ];

    this.gridOptions = {
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColDef,
      rowData: this.rowData,
      pagination: false,
      suppressHorizontalScroll: false,
      enableRangeSelection: true,
      enableCellTextSelection: true,
      ensureDomOrder: true,
      animateRows: true,
      rowHeight: 40,
      headerHeight: 40,
    };
  }

  private getStatusCellStyle(status: string) {
    if (status === 'PENDING') {
      return { background: '#ffe6e6' };
    }
    if (status === 'PARTIAL') {
      return { background: '#fff9c4' };
    }
    return null;
  }

  formatNumber(value: any, decimals: number = 2): string {
    if (value === null || value === undefined || isNaN(value)) return '';
    return Number(value).toLocaleString('en-IN', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  csrf() {
    this.userService.csrf().subscribe(
      (success) => {
        this._csrf = success._csrf;
        this.getData();
      },
      (error) => {
        this.notifSer.error("Error", error.error.message, defaults.notif);
      }
    );
  }

  goNext(type = 1) {
    if (type == 1) {
      this.filter.page++;
      this.getData();
    }
  }

  goPrev(type = 1) {
    if (type == 1) {
      if (this.filter.page > 1) {
        this.filter.page--;
        this.getData();
      }
    }
  }

  goBack() {
    this.request_id = "";
  }

  fromDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.filter["fromDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  toDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.filter["toDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  // Client-side quick search only (does NOT call the API)
  applyFilter(filterValue) {
    this.searchValue = filterValue || '';

    if (this.gridApi) {
      this.gridApi.setQuickFilter(this.searchValue);
    }

    this.applyFilterToLocalData(this.searchValue);
  }

  clearSearch() {
    this.searchValue = '';
    this.applyFilter('');
  }

  applyFilterToLocalData(searchValue: string) {
    if (searchValue) {
      const search = searchValue.toLowerCase();
      this.trades = this.oTrades.filter((x: any) => {
        return (
          (x.adminid && x.adminid.name && x.adminid.name.toLowerCase().includes(search)) ||
          (x.adminid && x.adminid.email && x.adminid.email.toLowerCase().includes(search)) ||
          (x.liquidity_provider_id && x.liquidity_provider_id.name && x.liquidity_provider_id.name.toLowerCase().includes(search)) ||
          (x.Type && x.Type.toLowerCase().includes(search)) ||
          (x.tx_hash && x.tx_hash.toLowerCase().includes(search)) ||
          (x.exchangeTradeStatus && x.exchangeTradeStatus.toLowerCase().includes(search))
        );
      });
    } else {
      this.trades = this.oTrades;
    }
  }

  getData() {
    this.spinnerService.show();
    this.filter._csrf = this._csrf;
    this.offrampService.getAllOfframpTrades(this.filter).subscribe((response: any) => {
      const list = (response && response.data) || [];
      this.trades = list;
      this.oTrades = list;
      this.rowData = list;

      if (this.gridApi) {
        this.gridApi.setRowData(this.rowData);
        if (this.searchValue) {
          this.gridApi.setQuickFilter(this.searchValue);
          this.applyFilterToLocalData(this.searchValue);
        } else {
          this.gridApi.setQuickFilter('');
          this.trades = this.oTrades;
        }
      }

      this.spinnerService.hide();
      this.prev_disabled = this.filter.page <= 1;
      this.next_disabled = !list || list.length < this.filter.limit;
    }, (error) => {
      this.spinnerService.hide();
      this.notifSer.error("Error", (error.error && error.error.message) || "Failed to fetch offramp trades", defaults.notif);
    });
  }

  displayProperJson(jsonData, eventType) {
    let obj = {
      jsonData: jsonData,
      eventType: eventType || "Offramp Trade"
    }
    this.dialog.open(ProperJsonDialogComponent, {
      width: 'auto',
      height: 'auto',
      data: obj,
    }).afterClosed().subscribe(result => {
    });
  }

  resetFilters() {
    this.filter = {
      page: 1,
      limit: 100,
      Type: '',
      exchangeTradeStatus: '',
      fromDate: moment().subtract(30, "d").format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    };

    this.searchValue = '';
    if (this.gridApi) {
      this.gridApi.setQuickFilter('');
    }

    this.trades = this.oTrades;
    this.getData();
  }

  addNewRecord() {
    const dialogRef = this.dialog.open(AddOfframpTradeDialog, {
      width: '700px',
      data: { record: {}, _csrf: this._csrf }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.getData();
      }
    });
  }

  bulkUpload() {
    const dialogRef = this.dialog.open(BulkUploadOfframpTradeDialog, {
      width: '700px',
      disableClose: true,
      data: { _csrf: this._csrf }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.getData();
      }
    });
  }

  editRecord(record: any) {
    const dialogRef = this.dialog.open(AddOfframpTradeDialog, {
      width: '700px',
      data: { record: record, _csrf: this._csrf }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.getData();
      }
    });
  }

  exportArray() {
    this.spinnerService.show();

    const exportFilter = {
      _csrf: this._csrf,
      fromDate: this.filter.fromDate,
      toDate: this.filter.toDate,
      page: 1,
      limit: 10000
    };

    this.offrampService.getAllOfframpTrades(exportFilter).subscribe(
      (response: any) => {
        const list = (response && response.data) || [];
        if (list.length > 0) {
          const exportData = list.map((x: any) => ({
            'Date': x.Date,
            'KeyPerson': x.adminid ? (x.adminid.name || x.adminid.email || '') : '',
            'Type': x.Type,
            'Liquidity Provider': x.liquidity_provider_id ? x.liquidity_provider_id.name : '',
            'Exchange Quote': x.exchange_quote_id ? `${x.exchange_quote_id.from_currency || ''} -> ${x.exchange_quote_id.to_currency || ''} @ ${x.exchange_quote_id.rate != null ? x.exchange_quote_id.rate : ''}` : '',
            'Rate': x.Rate,
            'Qty': x.Qty,
            'Fee %': x.feePercent,
            'Tx Hash': x.tx_hash,
            'Exchange Trade Status': x.exchangeTradeStatus,
            'Matched Topup Amount': x.MatchedTopupAmount,
            'Matched Status': x.MatchedStatus,
          }));
          TableUtil.exportArrayToExcel(exportData, 'OfframpTrades');
        } else {
          this.notifSer.info("Info", "No data available to export", defaults.notif);
        }
        this.spinnerService.hide();
      },
      (error) => {
        this.spinnerService.hide();
        this.notifSer.error("Error", "Failed to export data. Please try again.", defaults.notif);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/offramp-trades/offramp-trades.component.ts